import { defineComponent, h } from 'vue';
import { isValidURL, hasProtocol } from '@/ui/helpers/stringHelper';

export const QrCode = defineComponent({
  name: 'QrCode',
  props: ['item'],
  setup(props) {
    return function render() {
      return h('div', [
        props.item.responded
          ? isValidURL(props.item.response)
            ? h('a', {
              attrs: {
                href: hasProtocol(props.item.response) ? props.item.response : `//${props.item.response}`,
                target: '_blank',
              },
            }, props.item.response)
            : props.item.response
          : '-',
      ]);
    };
  },
});
